<template>
  <div class="position-relative">
    <SInput
      type="text"
      v-model="query"
      label="Search users"
      otherClasses="mb-0"
      :isSpinner="fetching"
      :plusUser="true"
      @atFocus="isInputFocused = true"
      @atBlur="isInputFocused = false"
      ref="searchInput"
      class="search-member-input"
      dataCy="groupMemberInput"
    />
    <div class="autocomplete-positioning md-scrollbar text-left">
      <SearchAutocompleteResults
        :query="query"
        :isInputFocused="isInputFocused"
        attachToInput
        :returnsTheItem="true"
        filterType="user"
        :excludeUsersId="chosenUsersId"
        @user="setUsers"
        @fetching="setFetching"
        @userSelected="resetQueryString"
        dataCy="groupMemberSelect"
      />
    </div>
    <md-content
      v-if="chosenUsers.length > 0"
      class="md-elevation-1 md-scrollbar selected-members"
      data-mcs-theme="dark"
      ref="membersBox"
      id="members-box"
    >
      <div v-for="(item, index) in chosenUsers" :key="item.id">
        <div class="my-2 pl-3 container" @click="$emit('user', item)">
          <div class="row">
            <div class="col mr-1 row-bg p-2 pl-3 rounded">
              <div class="author-thumb float-left">
                <SUserAvatar
                  :myUser="item"
                  size="small"
                  :isProfileAvatar="true"
                />
              </div>
              <div class="birthday-author-name float-left">
                <p class="author-name modal-text">
                  {{ getUserName(item) }}
                </p>
                <p class="author-username modal-text">@{{ item.username }}</p>
              </div>
              <SButtonMaterial
                class="close-icon float-right mt-2"
                :md-ripple="false"
                buttonType="button"
                textColor="white"
                iconColor="danger"
                iconWithoutText="cancel"
                materialClass="dense"
                @button="removeUser(index)"
                :data-cy="`remove-member-${index}`"
              />
            </div>
          </div>
        </div>
      </div>
    </md-content>

    <h5 v-if="chosenUsers.length === 0" class="mr-3 mt-5 mb-4">
      {{ selectedUsersText }}
    </h5>
  </div>
</template>

<script>
import SInput from "@/components/atoms/SInput";
import SearchAutocompleteResults from "@/components/molecules/SearchAutocompleteResults.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import GroupHelperVue from "../../mixins/GroupHelper.vue";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
import SButtonMaterial from "../../material-components/atoms/SButtonMaterial.vue";
import { mapGetters } from "vuex";

export default {
  name: "NewGroupMembers",
  mixins: [ChatHelperVue, UserHelperVue, GroupHelperVue],
  components: {
    SInput,
    SearchAutocompleteResults,
    SUserAvatar,
    SButtonMaterial,
  },
  data() {
    return {
      chosenUsers: [],
      chosenUsersId: [],
      fetching: false,
      timeStampFromLastChar: null,
      query: "",
      isInputFocused: false,
    };
  },
  watch: {
    getCurrentGroupMembers() {
      if (this.getCurrentGroupMembers.length > 0) {
        let test = [];
        this.getCurrentGroupMembers.forEach((user) => test.push(user.sUserId));
        this.chosenUsersId = test;
      }
    },
  },
  methods: {
    setUsers(u) {
      if (!this.chosenUsers.some((item) => item.id === u.id))
        this.chosenUsers.push(u);
      this.chosenUsersId.push(u.id);

      this.$refs.searchInput.focus();
      this.query = "";
    },
    removeUser(index) {
      this.chosenUsers.splice(index, 1);
      this.chosenUsersId.splice(index, 1);
    },
    storeMembers() {
      let users = [...this.chosenUsers];
      this.setNewGroupMembers(users);
    },
    resetChosenUsersAndQuery(){
      this.chosenUsers = [];
      this.query = "";
    },
    resetQueryString() {
      this.query = "";
      this.$emit("userWasChosen")
    },
    setFetching(newValue) {
      this.fetching = newValue;
    },
  },
  computed: {
    ...mapGetters({
      usersInvited: "getGroupInvitations",
      moderatorInvitation: "getGroupModeratorInvitations"
    }),
    selectedUsersText() {
      if (this.chosenUsers.length > 1) {
        return `${this.chosenUsers.length} users selected`;
      } else if (this.chosenUsers.length === 1) {
        return "1 user selected";
      } else {
        return "No members invited yet";
      }
    },
  },
  mounted() {
    if (this.getNewGroupMembers) {
      if (this.$route.name === "GroupsMembership") {
        this.chosenUsers = [...this.getNewGroupMembers];
        this.chosenUsers.forEach((user) => this.chosenUsersId.push(user.id));
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.header-img {
  height: 34px;
  width: 34px;
}
.close-icon {
  height: 24px;
  width: 24px;
  cursor: pointer;
  fill: lightslategray;
  min-width: unset;
}
.row-bg {
  background-color: $white;
}
.user-container {
  max-height: 200px;
  overflow-y: auto;
}
.autocomplete-positioning {
  position: absolute;
  z-index: 10010;
  left: 0;
  width: 100%;
}
.members-title {
  font-size: 18px;
  line-height: 20px;
  font-weight: bold;
  color: $black;
  display: flex;
  align-items: center !important;
  letter-spacing: 1.25px;
}
.selected-members {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  background: $white;
  margin-top: 24px;
}
#members-box {
  overflow: auto !important;
  max-height: 200px;
}
.author-name {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.8) !important;
  text-align: start;
}
.author-username {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}
.modal-text {
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 1.25px;
  margin-bottom: unset;
  margin-left: 8px;
}
</style>
